import { render, staticRenderFns } from "./InputSpesialisasi.vue?vue&type=template&id=32ac5f81&"
import script from "./InputSpesialisasi.vue?vue&type=script&lang=js&"
export * from "./InputSpesialisasi.vue?vue&type=script&lang=js&"
import style0 from "./InputSpesialisasi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports